export default __webpack_public_path__ + "static/media/login.9dc344fc.png";